import { Orientation } from '@/modules'
import Facade from '../../Facade'
import { ApplicationResizer } from './ApplicationResizer'

export class ApplicationDesktopResizer extends ApplicationResizer {
    protected detectOrientation(): Orientation {
        return Orientation.LANDSCAPE
    }

    protected updateGameStageBounds(): void {
        if (!Facade.displayConfig) return
        const { WORLD_WIDTH, WORLD_HEIGHT } = Facade.displayConfig.sizes.desktop

        this._gameStageBounds.height = WORLD_HEIGHT
        this._gameStageBounds.width = WORLD_WIDTH
    }

    public updateWrapperBounds(): void {
        this._wrapperBounds.height = this._viewWrapper.clientHeight
        this._wrapperBounds.width = this._viewWrapper.clientWidth
    }

    public updateCanvasSize(): void {
        const { width: worldWidth, height: worldHeight } = this._gameStageBounds
        const { width: wrapperWidth, height: wrapperHeight } = this._wrapperBounds

        Facade.app.stage.scale.set(1.0)
        super.updateCanvasSize()

        const fitScale = Math.min(wrapperWidth / worldWidth, wrapperHeight / worldHeight)
        const cssWidth = Math.round(worldWidth * fitScale)
        const cssHeight = Math.round(worldHeight * fitScale)

        this._canvas.style.width = `${cssWidth}px`
        this._canvas.style.height = `${cssHeight}px`
        this._canvas.style.left = `${Math.round((wrapperWidth - cssWidth) / 2)}px`
        this._canvas.style.top = `${Math.round((wrapperHeight - cssHeight) / 2)}px`
    }

    public get canvasHeight(): number {
        return this._gameStageBounds.height
    }

    public get canvasWidth(): number {
        return this._gameStageBounds.width
    }
}
